export default "__VITE_ASSET__BrwVk9gE__"